module.exports = Backbone.View.extend({
	template: require('./audit-list-item-child-view-template'),
	tagName: 'tbody',
	className: 'audit-list-child-item',

	initialize: function() {
		this.listenTo(this.model, 'change', this.render, this)
	}
})
